document.addEventListener('DOMContentLoaded', () => {
  const valueBar = document.getElementById('valueMarqueeContainer');
  const valueBarContent = document.getElementById('valueMarqueeContent');

  let isMarqueeActive = false; // Bandera para evitar duplicar contenido varias veces

  // Función para inicializar o reiniciar el marquee
  const initializeMarquee = () => {
    const contentWidth = valueBarContent.scrollWidth;
    const containerWidth = valueBar.offsetWidth;

    // Si el contenido es más ancho que el contenedor
    if (contentWidth > containerWidth) {
      if (!isMarqueeActive) {
        // Duplicar contenido para crear el efecto de loop continuo
        valueBarContent.innerHTML += valueBarContent.innerHTML;
        valueBarContent.classList.add('marqueeValue');
        isMarqueeActive = true;
      }
    } else {
      // Si el contenido cabe en el contenedor
      if (isMarqueeActive) {
        // Restaurar el contenido original y quitar la animación
        valueBarContent.innerHTML = valueBarContent.innerHTML.slice(0, contentWidth / 2);
        valueBarContent.classList.remove('marqueeValue');
        isMarqueeActive = false;
      }
    }
  };

  // Llamar al inicializador al cargar
  initializeMarquee();

  // Usar debounce para manejar el evento resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initializeMarquee(); // Reiniciar el marquee después del resize
    }, 150);
  });

  // Observar cambios en el contenido dinámico
  const observer = new MutationObserver(() => {
    initializeMarquee(); // Recalcular si el contenido cambia
  });

  observer.observe(valueBarContent, { childList: true, subtree: true });
});

